﻿export default class CartTimer {
    constructor() {
        this.circumference = 2 * Math.PI * 60;
        this.progressCircles = $(".circle-progress");
        this.timeTexts = $(".time-text");

        this.endTime = cleanupWillOccurAtViewBag; 
        this.originalTotalTime = cleanupTotalTimeViewBag; 
        document.addEventListener("cartUpdateEvent", () => {
            this._getTime(); // Fetch new time if cart updates
        });
        this.init();
    }

    init() {
        if (this.endTime && this.originalTotalTime) {
            this._startCountDown();
        }
    }

    _getTime() {
        let _this = this;
        $.ajax({
            url: "/Cart/GetReservationTimerData",
            dataType: "json",
            type: "GET",
            success: function (response) {
                if (!response.cleanupWillOccurAt || !response.cleanupTotalTime) {
                    console.error("Reponse does not conatin cleanup times");
                    return;
                }
                _this.endTime = parseInt(response.cleanupWillOccurAtUnix);
                _this.originalTotalTime = parseInt(response.cleanupTotalTime, 10);
                _this.updateCartAmount();
                _this._startCountDown();
            },
            error: function () {
                _this.endTime = null;
            }
        });
    }

    _startCountDown() {
        if (!this.endTime || !this.originalTotalTime) {
            return; 
        }

        $('.timer-container').removeClass('d-none').show();
        clearInterval(this.timerInterval);
        this._runCounter(); // Run immediately
        this.timerInterval = setInterval(() => this._runCounter(), 1000);
    }

    _runCounter() {
        let now = Math.floor(Date.now() / 1000);
        let endTime = this.endTime; 
        let timeLeft = endTime - now;

        if (timeLeft <= 0) {
            clearInterval(this.timerInterval);
            this.handleTimerEnd();
            return;
        }

        this.updateSVGTimers(timeLeft);
    }

    updateSVGTimers(timeLeft) {
        if (this.originalTotalTime <= 0) return;

        // Calculate dynamic progress
        const progress = (timeLeft / this.originalTotalTime) * this.circumference;

        this.progressCircles.each(function () {
            $(this).css("stroke-dashoffset", progress);
        });

        this.timeTexts.each(function () {
            $(this).text(CartTimer.formatTime(timeLeft));
        });
    }

    static formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    }



handleTimerEnd() {
    $.ajax({
        url: "/Cart/SeatReservationTimerHasEnded",
        dataType: "json",
        type: "GET",
        success: (response) => {
            if (response.success) {
                const seatReservationTimeEndedModal = document.getElementById("SeatReservationTimeEndedModal");
                if (seatReservationTimeEndedModal) {
                    $("#SeatReservationTimeEndedModal").modal('show');
                }
            }
            else {
                if (response.newTime && response.cleanupTotalTime) //TODO - test this!
                {
                    this.cleanupWillOccurAt = response.newTime;
                    this.cleanupTotalTime = response.cleanupTotalTime;
                    return this._startCountDown();

                }
                else {
                    window.location.href = "/";

                }
            }
        },
        error: function () {
            window.location.href = "/";
        }
    });
    }
    updateCartAmount() {
        fetch('/Cart/GetCartAmount')
            .then(response => response.json())
            .then(data => {
                document.querySelectorAll('.cart-counter').forEach(element => {
                    element.innerText = data;
                });
            })
            .catch(error => console.error('Error:', error));
    }
}
